import { Observable } from "rxjs";

export interface IndustryDivision {
    code: string;
    title: string;
}

export interface IndustrySubdivision {
    code: string;
    divisionCode: string;
    title: string;
}

export interface IndustryGroup {
    code: string;
    subdivisionCode: string;
    divisionCode: string;
    title: string;
}

export interface IndustryClass {
    code: string;
    groupCode: string;
    subdivisionCode: string;
    divisionCode: string;
    title: string;
}

export type GetIndustryDivisionsFn = () => Observable<IndustryDivision[]>;
export type GetIndustryGroupsByDivisionCodeFn = (divisionCode: string) => Observable<IndustryGroup[]>;
export type GetIndustryClassesByGroupCodeFn = (groupCode: string) => Observable<IndustryClass[]>;
export type GetIndustryDivisionTitleFn = (code: string) => Observable<string | null>;
export type GetIndustryGroupTitleFn = (code: string) => Observable<string | null>;
export type GetIndustryClassTitleFn = (code: string) => Observable<string | null>;